import { Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EmployeeSettingsTabTypes } from './types';
import Box from '@mui/material/Box';
import { TabSwitcher } from './TabSwitcher';

const EmployeeSettings = () => {
  const { t } = useTranslation('common');
  const [value, setValue] = useState<EmployeeSettingsTabTypes>(
    EmployeeSettingsTabTypes.GENERAL
  );
  const [AFASSelected, setAFASSelected] = useState<boolean>(false);
  const isAFASTab = (current) => {
    return (
      current === EmployeeSettingsTabTypes.AFAS_CONNECTORS ||
      current === EmployeeSettingsTabTypes.IMPORT_MAPPINGS
    );
  };

  const handleChange = (
    event: React.SyntheticEvent,
    newValue: EmployeeSettingsTabTypes
  ) => {
    setValue(newValue);
  };

  return (
    <Box pt={3}>
      <Tabs value={value} onChange={handleChange}>
        {Object.values(EmployeeSettingsTabTypes).map((tabItem, index) => {
          return (
            <Tab
              disabled={isAFASTab(tabItem) && !AFASSelected}
              key={index}
              value={tabItem}
              label={t(`employeeSettings.${tabItem}`)}
              component="a"
            />
          );
        })}
      </Tabs>
      <TabSwitcher setAFASSelected={setAFASSelected} currentTab={value} />
    </Box>
  );
};

export default EmployeeSettings;
